import actionTypes from './actionTypes';

const STATE_KEY = 'SWAGGERAPI';

const SET_PAGE_STATUS = `${STATE_KEY}/SET_PAGE_STATUS`;
const SET_API_VERSION = `${STATE_KEY}/SET_API_VERSION`;

const initialState = {
  url: null,
  subMenu: null,
  loading: false,
  pageIsMounted: false,
  activeApi: {},
  versions: [],
  selectedVersion: null,
};

export default function swaggerApi(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_URL: {
      const { payload } = action;
      return {
        ...state,
        url: payload.url,
      };
    }
    case actionTypes.LOAD_API: {
      const { payload } = action;
      return {
        ...state,
        loading: true,
        subMenu: null,
        pageIsMounted: false,
        activeApi: payload.activeApi,
        versions: payload.activeApi?.versions || [],
        selectedVersion: payload.activeApi?.defaultVersion,
        url: getApiUrl(payload.activeApi.defaultVersion, payload.activeApi.versions)
      };
    }
    case actionTypes.LOAD_API_SUCCESS: {
      const { payload } = action;

      return {
        ...state,
        loading: false,
        subMenu: payload.subMenu,
      };
    }

    case actionTypes.LOAD_API_FAILED: {
      return {
        ...state,
        loading: false,
      };
    }

    case SET_PAGE_STATUS: {
      return {
        ...state,
        pageIsMounted: action.payload.status
      }
    }

    case SET_API_VERSION: {
      const { version } = action.payload;
      const url = getApiUrl(version, state.versions);
      return {
        ...state,
        url,
        selectedVersion: version
      }
    }

    default:
      return state;
  }
}

export function getApiUrl(defaultVersion = 1, versions = []) {
  const url = versions.find((c) => c.version === defaultVersion) || {};
  return url.urlSpecification || '';
}

export function setApiVersion(payload) {
  return { type: SET_API_VERSION, payload };
}

export function setPageStatus(payload) {
  return { type: SET_PAGE_STATUS, payload };
}
